import React, { Suspense } from 'react'
import PageLoader from '../../component/Elements/pageLoader'
import { lazyWithRetry } from '../../helper/lazyWithRetry'

const CategoryDiscountsConfig = lazyWithRetry(() => import(/* webpackChunkName: "category-discount-edit" */'../../component/DiscountsConfig/CategoryDiscounts/CategoryDiscountsConfig'))

const CategoryDiscountsConfigPage = React.memo(() => {
	return (
		<Suspense fallback={<PageLoader />}>
			<CategoryDiscountsConfig />
		</Suspense>
	)
})

CategoryDiscountsConfigPage.displayName = 'CategoryDiscountsConfigPage'
export default CategoryDiscountsConfigPage
